module.exports = __webpack_public_path__ + "img/PALMAIARESORTS_logo_lg.png";